var locales = {
  'en': {
    'retryButtonText': 'Try again',
    'emptyResult': 'No data available'
  },
  'cs': {
    'retryButtonText': 'Zkusit znovu',
    'emptyResult': 'Nejsou k dispozici žádná data.'
  },
  'da': {
    'retryButtonText': 'Prøv igen',
    'emptyResult': 'Ingen tilgængelige data'
  },
  'de': {
    'retryButtonText': 'Erneut versuchen',
    'emptyResult': 'Keine Daten verfügbar'
  },
  'en-GB': {
    'retryButtonText': 'Try again',
    'emptyResult': 'No data available'
  },
  'es': {
    'retryButtonText': 'Inténtelo de nuevo.',
    'emptyResult': 'No hay datos disponibles.'
  },
  'fr': {
    'retryButtonText': 'Réessayer',
    'emptyResult': 'Aucune donnée disponible'
  },
  'fr-CA': {
    'retryButtonText': 'Réessayer',
    'emptyResult': 'Aucune donnée disponible'
  },
  'it': {
    'retryButtonText': 'Riprovare',
    'emptyResult': 'Nessun dato disponibile'
  },
  'ja': {
    'retryButtonText': 'もう一度試してください',
    'emptyResult': '使用できるデータがありません'
  },
  'ko': {
    'retryButtonText': '다시 시도',
    'emptyResult': '사용 가능한 데이터가 없습니다.'
  },
  'nl': {
    'retryButtonText': 'Probeer het opnieuw',
    'emptyResult': 'Geen gegevens beschikbaar'
  },
  'no': {
    'retryButtonText': 'Prøv igjen',
    'emptyResult': 'Ingen data tilgjengelig'
  },
  'pl': {
    'retryButtonText': 'Spróbuj ponownie',
    'emptyResult': 'Brak dostępnych danych'
  },
  'pt-BR': {
    'retryButtonText': 'Tente novamente',
    'emptyResult': 'Não há dados disponíveis'
  },
  'sv': {
    'retryButtonText': 'Försök igen',
    'emptyResult': 'Inga data är tillgängliga'
  },
  'zh-Hans': {
    'retryButtonText': '重试',
    'emptyResult': '无可用数据'
  },
  'zh-Hant': {
    'retryButtonText': '再試一次',
    'emptyResult': '無可用資料'
  }
};
export default locales;
//# sourceMappingURL=locales.js.map